import { i18n } from "@lingui/core";
import React, { useEffect } from 'react';
import cx from 'classnames';
import { CheveronRightIcon } from '@wkda/icons';
import { LoadingButton } from '@wkda/styleguide';
import { useFormState } from 'react-final-form';

function useWindowUnloadStatus() {
  const [windowUnloaded, setWindowUnloaded] = React.useState(false);

  const handleWindowUnload = () => {
    setWindowUnloaded(true);
  };

  useEffect(() => {
    window.addEventListener('unload', handleWindowUnload);
    return () => {
      window.removeEventListener('unload', handleWindowUnload);
      handleWindowUnload();
    };
  }, []);
  return {
    windowUnloaded
  };
}

const FormGlobalError = _ref => {
  let {
    className
  } = _ref;
  const {
    submitError,
    hasSubmitErrors
  } = useFormState({
    subscription: {
      error: true,
      submitError: true,
      hasSubmitErrors: true
    }
  });
  return hasSubmitErrors && submitError ? /*#__PURE__*/React.createElement("div", {
    className: cx(className)
  }, /*#__PURE__*/React.createElement("span", {
    className: "invalid-feedback"
  }, submitError)) : null;
};

export function CarleadCreationButton(_ref2) {
  let {
    children = i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.button'
    }),
    className,
    withGlobalError = true
  } = _ref2;
  const {
    windowUnloaded
  } = useWindowUnloadStatus();
  const {
    submitting,
    submitSucceeded,
    submitFailed
  } = useFormState({
    subscription: {
      submitting: true,
      submitSucceeded: true,
      submitFailed: true
    }
  });
  const submittingProcess = (submitting || submitSucceeded) && !submitFailed;
  return /*#__PURE__*/React.createElement("div", {
    className: "carlead-creation-form-button__container"
  }, /*#__PURE__*/React.createElement(LoadingButton, {
    variant: "secondary",
    type: "submit",
    loading: submittingProcess && !windowUnloaded,
    size: "lg",
    className: cx('carlead-creation-form-button', className),
    "data-qa-selector": "carlead-submit-button"
  }, children, /*#__PURE__*/React.createElement(CheveronRightIcon, {
    className: "ml-2"
  })), withGlobalError ? /*#__PURE__*/React.createElement(FormGlobalError, {
    className: "carlead-creation-form-button mb-2 mx-auto"
  }) : null);
}